<template>
  <div class="user-widget-trigger-wrapper">
    <UserWidget @click="toggle" />

    <UiPopover :open.sync="isOpen" :options="{ open: isOpen }">
      <div slot="trigger" class="chevronIcon">
        <UiBaseIcon width="10px" height="10px" icon-name="chevronDown" color="#9DA9B8" />
      </div>

      <div slot="content" @click="toggle">
        <!-- settings page link -->
        <UiLink :to="{ name: 'account' }">
          <UiPopoverItem>
            <span slot="label">Настройки аккаунта</span>
          </UiPopoverItem>
        </UiLink>

        <div slot="divider" class="divider" />

        <!-- Logout button -->
        <UiPopoverItem @click="approveExit">
          <UiBaseIcon
            slot="icon"
            class="action-icon"
            icon-name="logout"
            color="#ff6464"
            width="14px"
            height="14px"
          />

          <span slot="label" style="color: #ff6464">Выйти</span>
        </UiPopoverItem>
      </div>
    </UiPopover>
  </div>
</template>

<script>
import UiPopover from '@/components/UiPopover.vue'
import UserWidget from './UserWidget.vue'
import UiPopoverItem from '@/components/UiPopoverItem.vue'
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'
import UiLink from '@/components/UiLink.vue'

export default {
  components: { UiPopover, UiPopoverItem, UiBaseIcon, UserWidget, UiLink },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    open() {
      this.isOpen = true
    },
    toggle() {
      this.isOpen = !this.isOpen
    },
    async approveExit() {
      const result = await this.$swal.fire({
        title: 'Подтверждение',
        text: 'Выйти из кабинета?',
        showCancelButton: true,
        confirmButtonText: 'Выйти',
      })

      if (result.isConfirmed) {
        this.$router.push({ name: 'logout' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.user-widget-trigger-wrapper {
  margin-right: rem(-14px);

  @include createFlex(flexbox, nowrap, row, flex-end, center, center);
  @include flex-grow(1);

  @include media_desktop() {
    margin-right: 0;
  }

  .v-popover {
    .trigger {
      height: 100%;
    }

    @include createFlex(flexbox, nowrap, row, center, center, center);
  }

  .chevronIcon {
    height: 100%;
    margin: 16px 10px;
  }
}

.v-popover.open {
  .chevronIcon {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}

.divider {
  width: 100%;
  height: 1px;
  margin: 8px 0;
  background: $color-gray-25;
}
</style>
